<template>
    <div class="sport-tabs">
        <ul class="home-sports-list nav nav-tabs">
            <li class="nav-item" role="presentation" v-for="(sport, n_index) in [...primary_non_custom_sports]" :key="n_index">
                <router-link class="nav-link" :to="{ name: 'Home', params: { type: sport.slug, id: sport.id } }" 
                :class="[getPrimaryTabClass(n_index), { 'sport_id4': sport.id == '4', 'sport_id2': sport.id == '2', 'sport_id1': sport.id == '1'}]" @click="primarySportsTab(sport.slug, sport.id,n_index)">
                    <img :src="getSportImage(sport.id)" alt="sport" loading="lazy">
                    <span class="text-capitalize">{{ $t(sport.slug,sport.slug)}}</span>
                </router-link>
            </li>
            <li class="nav-item" role="presentation" v-if="checkEventManageforSingleType('worli-matka')">
                <router-link :to="{ name: 'matka' }" class="nav-link matka-head-11"
                    :class="{ active: $route.name == 'matka' }">
                    <span><img loading="lazy" src="@/assets/images/sports-matka.svg" alt="menu" /></span>
                    <span>{{ $t('matka','Matka')}}</span>
                </router-link>
            </li>
            <li class="nav-item" role="presentation" v-for="(sport, n_index) in [...custom_sports,...secondary_non_custom_sports]" :key="n_index">
                <router-link class="nav-link" :to="{ name: 'Home', params: { type: sport.slug, id: sport.id } }" 
                    :class="{ 'active': n_index === activeIndex }" 
                    @click="sportsTab(sport.slug, sport.id,n_index)">
                    <img :src="getSportImage(sport.id)" alt="sport" loading="lazy">
                    <span class="text-capitalize">{{ $t(sport.slug,sport.slug)}}</span>
                </router-link>
            </li>
        </ul>
    </div>
</template>

<script>
import { mapGetters } from 'vuex';
import { checkEventManageforSingleType } from '@/shared/services/eventLocks.js'; 
export default {
    name: "SportSelection",
    data() {
        return {
            clickApiUrl: process.env.VUE_APP_CLICK_API + 'v1/aws-s3/download/',
            activeIndex: null,
            primaryActiveIndex:0

        }
    },
    computed:{
        ...mapGetters({
			sports_list: 'sports_list'
		}),
        custom_sports(){
            return this.sports_list?.custom ?? [];
        },
        non_custom_sports(){
            return this.sports_list?.non_custom ?? [];
        },
        primary_non_custom_sports(){
            return this.sports_list?.non_custom?.filter(sport => [1,2,3,4].includes(sport.rank))?.sort((a, b) => [1, 3, 4].indexOf(a.rank) - [1, 3, 4].indexOf(b.rank)) || []
        },
        secondary_non_custom_sports(){
            return this.sports_list?.non_custom?.filter(sport => ![1,2,3,4].includes(sport.rank)) || []
        },
    },
    methods: {
        checkEventManageforSingleType,
        getPrimaryTabClass(index) {
            const colors = ['color1', 'color2', 'color3', 'color4'];
            return {
                [colors[index % colors.length]]: index === this.primaryActiveIndex,
                'active': index === this.primaryActiveIndex
            };
        },
        sportsTab(slug, id,index) {
            this.activeIndex = index;
            this.primaryActiveIndex = null;
            this.$emit('sportsSelection', id)
        },
        primarySportsTab(slug, id,index) {
            this.primaryActiveIndex = index;
            this.activeIndex = null;
            this.$emit('sportsSelection', id)
        },
        getSportImage(sportId) {
            const imageMap = {
            4: require("@/assets/images/sports-cricket.svg"),
            1: require("@/assets/images/sports-football.svg"),
            2: require("@/assets/images/sports-tennis.svg"),
            1477: require("@/assets/images/sports-rugby-league.svg"),
            6: require("@/assets/images/sports-boxing.svg"),
            5: require("@/assets/images/sports-rugby-union.svg"),
            3: require("@/assets/images/sports-golf.svg"),
            27454571: require("@/assets/images/sports-esports.svg"),
            2152880: require("@/assets/images/sports-gaelic-football.svg"),
            998917: require("@/assets/images/sports-volleyball.svg"),
            7524: require("@/assets/images/sports-ice-hockey.svg"),
            7522: require("@/assets/images/sports-basketball.svg"),
            7511: require("@/assets/images/sports-baseball.svg"),
            6423: require("@/assets/images/sports-american-football.svg"),
            6422: require("@/assets/images/sports-snooker.svg"),
            11: require("@/assets/images/sports-cycling.svg"),
            8: require("@/assets/images/sports-motor-sports.svg"),
            2378961: require("@/assets/images/sports-politics.svg"),
            468328: require("@/assets/images/sports-handball.svg"),
            61420: require("@/assets/images/sports-australian-rules.svg"),
            3503: require("@/assets/images/sports-darts.svg"),
            10: require("@/assets/images/sports-special-bets.svg"),
            26420387: require("@/assets/images/sports-mixed-martial-arts.svg"),
            4339: require("@/assets/images/sports-greyhound-racing.svg"),
            7: require("@/assets/images/sports-horse-racing.svg"),
            };
            return imageMap[sportId] || require("@/assets/images/sports-no.svg"); // Fallback image
        },
    }
};
</script>

<style scoped>
.width-100 {
    width: 100% !important;
}

.color1 {
    background-color: #20327b !important;
}

.color2 {
    background-color: #03b37f !important;
}

.color3 {
    background-color: #f18521 !important;
}
</style>